import React, { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/store';
import EditTracking from '../../editor/EditTracking';
import { TrackingTemplates } from './initValues';

export const initTrackingValues = {
  tracking: {
    background: ['show now - button'],
    button: ['close - button']
  }
};

const RatingAnswerSurveyTracking: FC = () => {
  let currentBranchIndex = useSelector(
    (state: RootState) => state.imageUpload.currentBranchIndex
  );

  return TrackingTemplates[currentBranchIndex];
};

export default RatingAnswerSurveyTracking;
